import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addSecurityProfile, updateSecurityProfile } from "../../Services/SecurityProfileService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {

      securityGroups: [],
      checkboxSecurityGroup: [],
      checkboxSecurityGroupSelected: [],

      securityKeys: [],
      checkboxSecurityKey: [],
      checkboxSecurityKeySelected: [],

      data: {
        id: '',
				name: '',
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        securityProfile: data,
        securityGroupProfileList: this.getSecurityGroupProfile(),
        securityProfileKeyList: this.getSecurityProfileKey()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        addSecurityProfile(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateSecurityProfile(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    return validated;
  }

  getSecurityGroupProfile() {
    let securityGroupProfiles = [];
    if(this.state.checkboxSecurityGroupSelected.length > 0){
      for(let j = 0; j < this.state.checkboxSecurityGroupSelected.length; j++){
        for(let i = 0; i < this.state.securityGroups.length; i++){
          if(this.state.checkboxSecurityGroupSelected[j].value === this.state.securityGroups[i].id){
            securityGroupProfiles.push( {securityGroup: this.state.securityGroups[i]} );
            break;
          }
        }
      }
    }
    return securityGroupProfiles;
  }

  getSecurityProfileKey() {
    let securityProfileKeys = [];
    if(this.state.checkboxSecurityKeySelected.length > 0){
      for(let j = 0; j < this.state.checkboxSecurityKeySelected.length; j++){
        for(let i = 0; i < this.state.securityKeys.length; i++){
          if(this.state.checkboxSecurityKeySelected[j].value === this.state.securityKeys[i].id){
            securityProfileKeys.push( {securityKey: this.state.securityKeys[i]} );
            break;
          }
        }
      }
    }
    return securityProfileKeys;
  }

  loadData(selected, securityGroups, securityGroupProfiles, securityKeys, securityProfileKeys) {
    let options = [];
    let optionsSelected = [];
    let obj = {};
    
    if(securityGroups !== undefined && securityGroups !== null && securityGroups.length > 0 && this.state.securityGroups.length === 0){
      if(securityGroupProfiles !== undefined && securityGroupProfiles !== null && securityGroupProfiles.length > 0){
        for(let i = 0; i < securityGroups.length; i++){
          obj = {value:securityGroups[i].id, label: securityGroups[i].name, checked: false};
          for(let j = 0; j < securityGroupProfiles.length; j++){
            if(securityGroups[i].id === securityGroupProfiles[j].securityGroup.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < securityGroups.length; i++){
          options.push({value:securityGroups[i].id, label: securityGroups[i].name, checked: false});
        }
      }
      
      this.setState({ 
        checkboxSecurityGroup: options,
        checkboxSecurityGroupSelected: optionsSelected,
        securityGroups: securityGroups
      })
    }

    if(securityKeys !== undefined && securityKeys !== null && securityKeys.length > 0 && this.state.securityKeys.length === 0){
      options = [];
      optionsSelected = [];
      if(securityProfileKeys !== undefined && securityProfileKeys !== null && securityProfileKeys.length > 0){
        for(let i = 0; i < securityKeys.length; i++){
          obj = {value:securityKeys[i].id, label: securityKeys[i].name, checked: false};
          for(let j = 0; j < securityProfileKeys.length; j++){
            if(securityKeys[i].id === securityProfileKeys[j].securityKey.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < securityKeys.length; i++){
          options.push({value:securityKeys[i].id, label: securityKeys[i].name, checked: false});
        }
      }

      this.setState({ 
        checkboxSecurityKey: options, 
        checkboxSecurityKeySelected: optionsSelected,
        securityKeys: securityKeys 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, securityGroups, securityGroupProfiles, securityKeys, securityProfileKeys } = this.props;
    this.loadData(selected, securityGroups, securityGroupProfiles, securityKeys, securityProfileKeys);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.securityGroups !== this.props.securityGroups || 
        props.securityGroupProfiles !== this.props.securityGroupProfiles || props.securityKeys !== this.props.securityKeys || 
        props.securityProfileKeys !== this.props.securityProfileKeys){
      this.loadData(this.props.selected, this.props.securityGroups, this.props.securityGroupProfiles, this.props.securityKeys, this.props.securityProfileKeys);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxSecurityGroup(event) {
    let selecteds = [];

    event.checked = !event.checked;
    if(this.state.checkboxSecurityGroupSelected.length > 0){
      for(let i = 0; i < this.state.checkboxSecurityGroupSelected.length; i++){
        if(this.state.checkboxSecurityGroupSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxSecurityGroupSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }

    this.setState({ 
      checkboxSecurityGroupSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1)
    });
  }

  updateCheckboxSecurityKey(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxSecurityKeySelected.length > 0){
      for(let i = 0; i < this.state.checkboxSecurityKeySelected.length; i++){
        if(this.state.checkboxSecurityKeySelected[i].value !== event.value){
          selecteds.push(this.state.checkboxSecurityKeySelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxSecurityKeySelected: selecteds });
  }


  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';

    this.setState({ 
      data,
      checkboxSecurityGroupSelected: [],
      checkboxSecurityKeySelected: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_SECURITY_PROFILE_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesSecurityGroup = [];
    let checkboxesSecurityKey = [];
    let checked = false;

    let total = this.state.checkboxSecurityGroup.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checked = false;
        checkboxesSecurityGroup.push(
          <div key={"divsecurityGroups_"+this.state.checkboxSecurityGroup[i].value} className='form__form-inline' style={{width: '285px'}}>
            <input type="checkbox" 
              id={"checkboxsecurityGroups_"+this.state.checkboxSecurityGroup[i].value} 
              name={"checkboxsecurityGroups_"+this.state.checkboxSecurityGroup[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSecurityGroup(this.state.checkboxSecurityGroup[i])}
              checked={this.state.checkboxSecurityGroupSelected.includes(this.state.checkboxSecurityGroup[i])} 
            />
              <label 
                key={"labelsecurityGroups_"+this.state.checkboxSecurityGroup[i].value}
                htmlFor={"checkboxsecurityGroups_"+this.state.checkboxSecurityGroup[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxSecurityGroup[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxSecurityKey.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesSecurityKey.push(
          <div key={"divsecurityKeys_"+this.state.checkboxSecurityKey[i].value} className='form__form-inline' style={{width: '285px'}}>
            <input type="checkbox" 
              id={"checkboxsecurityKeys_"+this.state.checkboxSecurityKey[i].value} 
              name={"checkboxsecurityKeys_"+this.state.checkboxSecurityKey[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSecurityKey(this.state.checkboxSecurityKey[i])}
              checked={this.state.checkboxSecurityKeySelected.includes(this.state.checkboxSecurityKey[i])} 
            />
              <label 
                key={"labelsecurityKeys_"+this.state.checkboxSecurityKey[i].value}
                htmlFor={"checkboxsecurityKeys_"+this.state.checkboxSecurityKey[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxSecurityKey[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="hidden" 
                    name="id"
                    value={this.state.data.id} />
                  <input type="text" 
                    name="name"
                    value={this.state.data.name}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>
              
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.securityGroup_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', fontSize: '10px'}}>
                  
                  {checkboxesSecurityGroup}

                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.securityKey_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', fontSize: '9px'}}>
                  
                  {checkboxesSecurityKey}

                </div>
              </div>



              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'securityProfileEdit', 
})(withTranslation('common')(CrudEdit));
